import React from "react"
import PropTypes from "prop-types"
import { NumericFormat } from "react-number-format"
import { TextField } from "@mui/material"

const TextFieldNumber = ({
  value,
  label,
  onChange = () => {},
  onBlur = () => {},
  prefix,
  suffix,
  readOnly = false,
  isPercentage = false,
  disabled = false,
  variant = "outlined",
  size = "medium",
  InputProps = {},
  sx = {},
  decimalScale = 2,
  allowNegative = true,
  fixedDecimalScale = true,
}) => {
  const materialUITextFieldProps = {
    id: "filled-multiline-flexible",
    variant,
    label,
    fullWidth: true,
    InputProps: suffix ? { ...InputProps, endAdornment: suffix } : InputProps,
    sx: {
      cursor: disabled ? "not-allowed" : "default",
      ...sx,
    },
    size,
  }

  return (
    <NumericFormat
      disabled={disabled}
      value={value}
      thousandSeparator={false}
      decimalSeparator="."
      allowNegative={allowNegative}
      customInput={TextField}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      locale="es-ES"
      prefix={prefix}
      suffix={!suffix && isPercentage ? "%" : undefined}
      {...materialUITextFieldProps}
      isAllowed={values => {
        if (readOnly) return false
        if (values.value === "") return true
        if (isPercentage) {
          return values.floatValue >= 0 && values.floatValue <= 100
        }
        return true
      }}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo?.source !== "event") return
        const newValue = values.floatValue ?? ""
        onChange(newValue)
      }}
      onBlur={e => {
        if (e.target.value === "") {
          onChange(0)
        }
        if (typeof onBlur === "function") {
          onBlur(e.target.value === "" ? 0 : e.target.value)
        }
      }}
    />
  )
}

TextFieldNumber.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  isPercentage: PropTypes.bool,
  disabled: PropTypes.bool,
  allowNegative: PropTypes.bool,
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  InputProps: PropTypes.object,
  sx: PropTypes.object,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
}

export default TextFieldNumber
